import { gql } from '@apollo/client';

export const UPDATE_DRAFT_MUTATION = gql`
    mutation updateDraftMutation($input: UpdateDraftInput) {
        updateDraftMutation(input: $input) {
            status
            categories
            textBlocks {
                id
                type
                data {
                    paragraph
                    header
                    level
                    items {
                        id
                        text
                    }
                    file {
                        url
                    }
                    code
                    withBorder
                    withBackground
                    stretched
                    caption
                    style
                }
            }
            textBlocksVersions {
                blocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
                id
            }
            createdAt
            updatedAt
            id
        }
    }
`;
